import { render, staticRenderFns } from "./OneImageLayout.vue?vue&type=template&id=f00952e0"
import script from "./OneImageLayout.vue?vue&type=script&lang=js"
export * from "./OneImageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports